// extracted by mini-css-extract-plugin
export default {"Left":"Error404_Left__YAaZm"};